import React, { useState } from "react";
import styles from "./MCADocumentsPage.module.css";
import { Link, useNavigate } from "react-router-dom";
import Nav from "../../Components/LandingPage/Nav/Nav";
import Footer from "../../Components/LandingPage/Footer/Footer";
import { FaRegBuilding, FaSearch, FaCreditCard, FaDownload, FaCheckCircle, FaRegClock, FaRegCalendarAlt, FaShoppingCart } from "react-icons/fa";
import { MdOutlineCreditCard } from "react-icons/md";
import { HiDocumentText } from "react-icons/hi";
import { FaShieldAlt } from "react-icons/fa";
import {
    searchCompaniesPublic,
    getAllDocumentPlans,
    getStates,
    createMcaDocumentsAndDataRazorpayOrder,
    handleMcaDocumentsAndDataPaymentSuccess,
    getUserPurchasedMcaDocuments,
    searchUserPurchasedMcaDocuments,
    addCart,
    getCarts,
    deleteCartItem,
    getUserInvoiceForm
} from "../../Services/APIrequests";
import useStore from "../../Store";
import { useEffect, useMemo } from "react";
import { RotatingLines } from "react-loader-spinner";
import { SuccessSwal, warningSwal } from "../../Util/Toast";

const mockDocuments = [
    { company: "Reliance Industries Ltd", cin: "L17110MH1973PLC019786", purchased: "12 Mar 2026", status: "Ready" },
    { company: "Tata Consultancy Services Ltd", cin: "L22210MH2004PLC146415", purchased: "08 Mar 2026", status: "Ready" },
    { company: "Infosys Limited", cin: "L85110KA1981PLC013115", purchased: "01 Mar 2026", status: "Ready" },
    { company: "HDFC Bank Ltd", cin: "L65920MH1994PLC080618", purchased: "25 Feb 2026", status: "Processing" }
];

const DocumentCard = ({ doc, styles, onDownload, docType }) => {
    const statusStr = doc.status != null ? String(doc.status).toLowerCase() : "";
    const isReady = statusStr === "ready" || statusStr === "success";
    const purchaseYear = doc.dateOfPurchase ? new Date(doc.dateOfPurchase).getFullYear() : "N/A";
    const formattedDate = doc.dateOfPurchase ? new Date(doc.dateOfPurchase).toLocaleString("en-GB", {
        day: "numeric",
        month: "short",
        year: "numeric",
        hour: "2-digit",
        minute: "2-digit",
        hour12: true
    }) : "N/A";

    return (
        <div className={styles.docCard}>
            <div className={styles.docCardContent}>
                <div className={styles.docCardHeader}>
                    <h3 className={styles.docCompanyTitle}>{doc.CompanyName || doc.CompanyName || "N/A"}</h3>
                    <div className={`${styles.docStatusBadge} ${isReady ? styles.statusReady : styles.statusProcessing}`}>
                        {isReady ? <FaCheckCircle /> : <FaRegClock />}
                        {doc.status}
                    </div>
                </div>

                <p className={styles.docCin}>CIN: {doc.CIN}</p>

                <div className={styles.docDetailsGrid}>
                    <div className={styles.docDetailItem}>
                        <FaRegCalendarAlt className={styles.docIcon} />
                        <span>Purchased: {formattedDate}</span>
                    </div>
                    <div className={styles.docDetailItem}>
                        <FaCreditCard className={styles.docIcon} />
                        <span>Amount: ₹{doc.amount}</span>
                    </div>
                </div>

                <div className={styles.docTags}>
                    <span className={styles.docTypeTag}>MCA Document</span>
                    <span className={styles.docYearTag}>{purchaseYear}</span>
                </div>

                {/* <div className={styles.docFinancials}>
                    <div className={styles.docFinItem}>
                        <span className={styles.docFinLabel}>Annual Returns:</span>
                        <span className={styles.docFinValue}>{Array.isArray(doc.annualReturnsAndBalanceSheeteForms) ? doc.annualReturnsAndBalanceSheeteForms.length : 0}</span>
                    </div>
                    <div className={styles.docFinItem}>
                        <span className={styles.docFinLabel}>Certificates:</span>
                        <span className={styles.docFinValue}>{Array.isArray(doc.certificates) ? doc.certificates.length : 0}</span>
                    </div>
                    <div className={styles.docFinItem}>
                        <span className={styles.docFinLabel}>Director Changes:</span>
                        <span className={styles.docFinValue}>{Array.isArray(doc.changeDirectorsOrDesignatedPartner) ? doc.changeDirectorsOrDesignatedPartner.length : 0}</span>
                    </div>
                    <div className={styles.docFinItem}>
                        <span className={styles.docFinLabel}>Charge Docs:</span>
                        <span className={styles.docFinValue}>{Array.isArray(doc.chargeDocument) ? doc.chargeDocument.length : 0}</span>
                    </div>
                    <div className={styles.docFinItem}>
                        <span className={styles.docFinLabel}>Incorporation:</span>
                        <span className={styles.docFinValue}>{Array.isArray(doc.incorporationDocument) ? doc.incorporationDocument.length : 0}</span>
                    </div>
                    <div className={styles.docFinItem}>
                        <span className={styles.docFinLabel}>LLP Forms:</span>
                        <span className={styles.docFinValue}>{Array.isArray(doc.llpForms) ? doc.llpForms.length : 0}</span>
                    </div>
                    <div className={styles.docFinItem}>
                        <span className={styles.docFinLabel}>e-Form Docs:</span>
                        <span className={styles.docFinValue}>{Array.isArray(doc.othereFormDocuments) ? doc.othereFormDocuments.length : 0}</span>
                    </div>
                    <div className={styles.docFinItem}>
                        <span className={styles.docFinLabel}>Others:</span>
                        <span className={styles.docFinValue}>{Array.isArray(doc.other) ? doc.other.length : 0}</span>
                    </div>
                </div> */}

                <div className={styles.docCardFooter}>
                    <div className={styles.docActionButtons}>
                        {isReady ? (
                            <Link to={`/CompanymcadocDetails/${doc.CIN}`} state={{ docType: docType }} className={styles.docDownloadBtn}>
                                Details
                            </Link>
                        ) : (
                            <button
                                className={`${styles.docDownloadBtn} ${styles.disabledDetailsBtn}`}
                                disabled
                                title="This document is currently being processed. Full details will be available once it is Ready."
                            >
                                Details
                            </button>
                        )}
                        {/* <button
                            className={styles.docDownloadBtn}
                            onClick={() => onDownload(doc)}
                            disabled={!isReady}
                        >
                            <FaDownload /> Download
                        </button> */}
                    </div>
                </div>
            </div>
        </div>
    );
};

const MCADocumentsPage = () => {
    const navigate = useNavigate();
    const { setCartCount, cartCount } = useStore();
    const [activeTab, setActiveTab] = useState("myDocuments");
    const [addingToCartCIN, setAddingToCartCIN] = useState(null);
    const [removingFromCartCIN, setRemovingFromCartCIN] = useState(null);
    const [cartItemsMap, setCartItemsMap] = useState({});
    const [buyingCIN, setBuyingCIN] = useState(null);
    const [cartForPayment, setCartForPayment] = useState(null);

    // Authentication status
    const isLoggedIn = Boolean(sessionStorage.getItem("token"));

    // Search state for "Buy New Company Data"
    const [buyNewSearchTerm, setBuyNewSearchTerm] = useState("");
    const [searchResults, setSearchResults] = useState([]);
    const [isSearching, setIsSearching] = useState(false);
    const [searchStatus, setSearchStatus] = useState(null);
    const [mcaPlans, setMcaPlans] = useState([]);
    const [purchasedDocs, setPurchasedDocs] = useState([]);
    const [isLoadingDocs, setIsLoadingDocs] = useState(false);
    const [myDocsSearchTerm, setMyDocsSearchTerm] = useState("");
    const [currentPage, setCurrentPage] = useState(1);
    const [paginationData, setPaginationData] = useState({
        totalPages: 1,
        totalCounts: 0
    });

    // Payment and Billing States
    const [showBillingModal, setShowBillingModal] = useState(false);
    const [statesList, setStatesList] = useState([]);
    const [selectedCompany, setSelectedCompany] = useState(null);
    const [billingDetails, setBillingDetails] = useState({
        fullName: "",
        email: "",
        mobileNumber: "",
        address1: "",
        address2: "",
        city: "",
        state: "",
        pincode: "",
        GSTIN: "",
        invoiceType: "B2C",
    });

    useEffect(() => {
        // Pre-fill from session
        const name = sessionStorage.getItem("fullName") || "";
        const email = sessionStorage.getItem("email") || "";
        setBillingDetails(prev => ({
            ...prev,
            fullName: name,
            email: email,
        }));

        const fetchInitialData = async () => {
            try {
                const plansRes = await getAllDocumentPlans();
                if (plansRes.data.success) {
                    setMcaPlans(plansRes.data.mcaDocumentsAndData);
                }

                const statesRes = await getStates();
                setStatesList(statesRes.data.states || []);

                // Initial fetch is handled by the search effect
            } catch (error) {
                console.error("Error fetching initial data:", error);
            }
        };
        fetchInitialData();
    }, []);

    const fetchPurchasedDocs = async (page) => {
        if (!isLoggedIn) return;
        setIsLoadingDocs(true);
        try {
            let response;
            if (myDocsSearchTerm.trim()) {
                response = await searchUserPurchasedMcaDocuments(myDocsSearchTerm, page, 10, "new");
            } else {
                response = await getUserPurchasedMcaDocuments(page, 10, "new");
            }

            if (response.data.success) {
                const raw = response.data.userPurchasedMcaDocuments || response.data.searchUserPurchasedMcaDocuments || [];
                // Flat response — normalize status and amount field names
                const docs = raw.map(item => ({
                    ...item,
                    status: item.docOrderItemStatus || item.status,
                    amount: item.price || item.amount,
                }));
                setPurchasedDocs(docs);
                setPaginationData({
                    totalPages: response.data.pagination.totalPages,
                    totalCounts: response.data.pagination.totalCounts
                });
                setCurrentPage(response.data.pagination.currentPage);
            }
        } catch (error) {
            console.error("Error fetching purchased documents:", error);
        } finally {
            setIsLoadingDocs(false);
        }
    };

    // Debounce for My Documents search
    useEffect(() => {
        if (isLoggedIn) {
            const delay = setTimeout(() => {
                fetchPurchasedDocs(1);
            }, 300);
            return () => clearTimeout(delay);
        }
    }, [myDocsSearchTerm, isLoggedIn]);

    const handlePageChange = (newPage) => {
        if (isLoggedIn && newPage >= 1 && newPage <= paginationData.totalPages) {
            fetchPurchasedDocs(newPage);
        }
    };

    const documentPrice = mcaPlans.find(plan => plan.type === "documents")?.price || 399;

    const subtotal = documentPrice;
    const gstPercentage = 18;
    const gstAmount = subtotal * (gstPercentage / 100);
    const totalAmount = subtotal + gstAmount;
    const roundedTotal = parseFloat(totalAmount.toFixed(2));

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setBillingDetails(prev => ({
            ...prev,
            [name]: value,
        }));
    };

    const handleBuyClick = async (company) => {
        if (!isLoggedIn) {
            warningSwal("Login Required", "Please login to purchase company data.");
            navigate("/login", { state: { from: "/mca-documents" } });
            return;
        }
        const cin = company.CIN || company.cin;
        setBuyingCIN(cin);
        try {
            // Add to cart first (ignore if already exists)
            await addCart({ CIN: cin, price: String(documentPrice), quantity: 1 }).catch(() => {});

            // Fetch cart and saved invoice form in parallel
            const [cartRes, invoiceRes] = await Promise.all([
                getCarts(),
                getUserInvoiceForm().catch(() => null),
            ]);

            if (cartRes.data?.Status === 1) {
                setCartForPayment(cartRes.data);
                const map = {};
                (cartRes.data.docCartItems || []).forEach(item => { map[item.CIN] = item.docCartItemId; });
                setCartItemsMap(map);
                setCartCount(cartRes.data.docCartItemCount || 0);
                setSearchResults(prev => prev.map(c => (c.CIN || c.cin) === cin ? { ...c, isInCart: 1 } : c));
            }

            // Prefill billing form from saved invoice data if available
            if (invoiceRes?.data?.Status === 1 && invoiceRes.data.data) {
                const d = invoiceRes.data.data;
                setBillingDetails({
                    fullName: d.fullName || "",
                    email: d.email || "",
                    mobileNumber: d.mobileNumber || "",
                    address1: d.address1 || "",
                    address2: d.address2 || "",
                    city: d.city || "",
                    state: d.state || "",
                    pincode: d.pincode || "",
                    GSTIN: d.GSTIN || "",
                    invoiceType: d.invoiceType || "B2C",
                });
            }

            setSelectedCompany(company);
            setShowBillingModal(true);
        } catch (error) {
            warningSwal("Error", "Failed to process. Please try again.");
        } finally {
            setBuyingCIN(null);
        }
    };


    const handleFinalPayment = async () => {
        const { fullName, email, mobileNumber, address1, city, state, pincode } = billingDetails;
        if (!fullName || !email || !mobileNumber || !address1 || !city || !state || !pincode) {
            warningSwal("Incomplete Details", "Please fill in all required fields.");
            return;
        }

        if (!cartForPayment?.docCartId) {
            warningSwal("Cart Error", "Cart data not found. Please try again.");
            return;
        }

        const docCartId = cartForPayment.docCartId;
        const docCartItems = cartForPayment.docCartItems || [];
        const cartSubtotal = cartForPayment.amount || subtotal;
        const cartGst = parseFloat((cartSubtotal * (gstPercentage / 100)).toFixed(2));
        const cartTotal = parseFloat((cartSubtotal + cartGst).toFixed(2));

        try {
            const orderResponse = await createMcaDocumentsAndDataRazorpayOrder({
                docCartId,
                docCartItems,
                amount: cartSubtotal,
                gstAmount: cartGst,
                totalAmount: cartTotal,
            });

            if (orderResponse.status === 200 || orderResponse.status === 201) {
                const razorpay_orderId = orderResponse.data.data.razorpay_orderId;

                const successPayload = {
                    ...billingDetails,
                    docCartId,
                    subtotal: cartSubtotal,
                    gstPercentage,
                    gstAmount: cartGst,
                    totalamount: cartTotal,
                    razorpay_order_id: razorpay_orderId,
                };

                const options = {
                    key: process.env.REACT_APP_RAZORPAYKEY_TEST,
                    amount: Math.round(cartTotal * 100),
                    currency: "INR",
                    name: "Kohere",
                    description: `MCA Documents for ${selectedCompany.CompanyName || selectedCompany.entityName}`,
                    order_id: razorpay_orderId,
                    handler: async (razorpayResponse) => {
                        try {
                            const body = {
                                ...successPayload,
                                razorpay_payment_id: razorpayResponse.razorpay_payment_id,
                                razorpay_signature: razorpayResponse.razorpay_signature,
                            };
                            const response = await handleMcaDocumentsAndDataPaymentSuccess(body);
                            if (response.status === 200) {
                                await SuccessSwal("Success!", response.data.message || "Payment successful! Documents are being prepared.");
                                setCartForPayment(null);
                                setCartCount(0);
                                setSearchResults([]);
                                setBuyNewSearchTerm("");
                                navigate("/mca-documents");
                            } else {
                                warningSwal("Payment Failed", response.data?.message || "Payment verification failed.");
                            }
                        } catch (err) {
                            console.error("Payment success error:", err);
                            warningSwal("Error", "An error occurred after payment. Please contact support.");
                        }
                    },
                    prefill: {
                        name: billingDetails.fullName,
                        email: billingDetails.email,
                        contact: billingDetails.mobileNumber,
                    },
                    theme: { color: "#2563eb" },
                };

                setShowBillingModal(false);
                const rzp = new window.Razorpay(options);
                rzp.open();
            } else {
                warningSwal("Payment Error", "Failed to create order. Please try again.");
            }
        } catch (error) {
            console.error("Order creation error:", error);
            warningSwal("Payment Error", "Failed to initiate payment. Please try again.");
        }
    };

    const handleBuyMoreCredits = () => {
        navigate("/credit-packages");
    };

    const fetchCartMap = async () => {
        if (!isLoggedIn) return;
        try {
            const res = await getCarts();
            if (res.data?.Status === 1) {
                const map = {};
                (res.data.docCartItems || []).forEach(item => {
                    map[item.CIN] = item.docCartItemId;
                });
                setCartItemsMap(map);
                setCartCount(res.data.docCartItemCount || 0);
            }
        } catch (_) {}
    };

    useEffect(() => {
        if (isLoggedIn) fetchCartMap();
    }, [isLoggedIn]);

    const handleAddToCart = async (company) => {
        if (!isLoggedIn) {
            warningSwal("Login Required", "Please login to add items to cart.");
            navigate("/login", { state: { from: "/mca-documents" } });
            return;
        }
        const cin = company.CIN || company.cin;
        setAddingToCartCIN(cin);
        try {
            const res = await addCart({ CIN: cin, price: String(documentPrice), quantity: 1 });
            if (res.status === 200 || res.status === 201) {
                SuccessSwal("Added to Cart", `${company.CompanyName || company.entityName} added to cart.`);
                setCartCount(cartCount + 1);
                // Refresh cart map to get the new docCartItemId
                const cartRes = await getCarts();
                if (cartRes.data?.Status === 1) {
                    const map = {};
                    (cartRes.data.docCartItems || []).forEach(item => { map[item.CIN] = item.docCartItemId; });
                    setCartItemsMap(map);
                    setCartCount(cartRes.data.docCartItemCount || 0);
                }
                // Update isInCart in search results
                setSearchResults(prev => prev.map(c => (c.CIN || c.cin) === cin ? { ...c, isInCart: 1 } : c));
            } else {
                warningSwal("Error", res.data?.message || "Failed to add to cart.");
            }
        } catch (error) {
            warningSwal("Error", error?.response?.data?.message || "Failed to add to cart.");
        } finally {
            setAddingToCartCIN(null);
        }
    };

    const handleRemoveFromCart = async (company) => {
        const cin = company.CIN || company.cin;
        const docCartItemId = cartItemsMap[cin];
        if (!docCartItemId) return;
        setRemovingFromCartCIN(cin);
        try {
            const res = await deleteCartItem(docCartItemId);
            if (res.status === 200) {
                SuccessSwal("Removed", `${company.CompanyName || company.entityName} removed from cart.`);
                setCartCount(Math.max(0, cartCount - 1));
                setCartItemsMap(prev => { const m = { ...prev }; delete m[cin]; return m; });
                setSearchResults(prev => prev.map(c => (c.CIN || c.cin) === cin ? { ...c, isInCart: 0 } : c));
            } else {
                warningSwal("Error", res.data?.message || "Failed to remove from cart.");
            }
        } catch (error) {
            warningSwal("Error", error?.response?.data?.message || "Failed to remove from cart.");
        } finally {
            setRemovingFromCartCIN(null);
        }
    };

    // Search logic similar to home_content1.jsx
    useEffect(() => {
        if (isLoggedIn) {
            const delay = setTimeout(() => {
                if (buyNewSearchTerm.trim().length >= 3) {
                    performSearch();
                } else {
                    setSearchResults([]);
                }
            }, 800);

            return () => clearTimeout(delay);
        }
    }, [buyNewSearchTerm, isLoggedIn]);

    const performSearch = async () => {
        if (!isLoggedIn) return;
        setIsSearching(true);
        try {
            const response = await searchCompaniesPublic({ name: buyNewSearchTerm });
            if (response.status === 200) {
                setSearchStatus(response.data.Status);
                setSearchResults(response.data.companies || []);
            } else {
                setSearchResults([]);
            }
        } catch (error) {
            console.error("Search error:", error);
            setSearchResults([]);
        } finally {
            setIsSearching(false);
        }
    };

    return (
        <>
            <Nav />
            <div className={styles.pageWrapper}>
                <div className={styles.container}>
                    {/* Header */}
                    <div className={styles.header}>
                        <div className={styles.headerIcon}>
                            <HiDocumentText size={24} color="#3b82f6" />
                        </div>
                        <div>
                            <h1 className={styles.title}>MCA Documents</h1>
                            <p className={styles.subtitle}>Access company filings, compliance data & MCA records</p>
                        </div>
                    </div>

                    {/* Credits Card */}
                    {/* <div className={styles.creditsCard}>
                    <div className={styles.creditsLeft}>
                        <div className={styles.creditsIconBg}>
                            <MdOutlineCreditCard size={20} color="#10b981" />
                        </div>
                        <div>
                            <p className={styles.creditsLabel}>Available Credits</p>
                            <h2 className={styles.creditsValue}>15</h2>
                        </div>
                    </div>
                    <button className={styles.buyCreditsBtn} onClick={handleBuyMoreCredits}>
                        + Buy More Credits
                    </button>
                </div> */}

                    {/* Tabs */}
                    <div className={styles.tabsContainer}>
                        <button
                            className={`${styles.tabBtn} ${activeTab === 'myDocuments' ? styles.activeTab : ''}`}
                            onClick={() => setActiveTab('myDocuments')}
                        >
                            <HiDocumentText className={styles.tabIcon} /> My Documents ({purchasedDocs.length})
                        </button>
                        <button
                            className={`${styles.tabBtn} ${activeTab === 'buyNew' ? styles.activeTab : ''}`}
                            onClick={() => setActiveTab('buyNew')}
                        >
                            <FaSearch className={styles.tabIcon} /> Buy New Company Data
                        </button>
                    </div>

                    {/* Tab Content */}
                    {activeTab === 'myDocuments' && (
                        <div className={styles.contentCard}>
                            {isLoggedIn ? (
                                <>
                                    <div className={styles.searchContainer}>
                                        <FaSearch className={styles.searchIcon} color="#6b7280" />
                                        <input
                                            type="text"
                                            placeholder="Search by company name or CIN..."
                                            className={styles.searchInput}
                                            value={myDocsSearchTerm}
                                            onChange={(e) => setMyDocsSearchTerm(e.target.value)}
                                        />
                                    </div>

                                    <div className={styles.docsGrid}>
                                        {isLoadingDocs ? (
                                            <div className={styles.loaderContainerFull}>
                                                <RotatingLines
                                                    strokeColor="#3b82f6"
                                                    strokeWidth="5"
                                                    animationDuration="0.75"
                                                    width="60"
                                                    visible={true}
                                                />
                                                <p>Loading your documents...</p>
                                            </div>
                                        ) : purchasedDocs.length > 0 ? (
                                            purchasedDocs.map((doc, index) => (
                                                <DocumentCard
                                                    key={doc.docOrderItemId || doc.id || index}
                                                    doc={doc}
                                                    styles={styles}
                                                    onDownload={(d) => console.log("Download", d)}
                                                    docType="new"
                                                />
                                            ))
                                        ) : (
                                            <div className={styles.noDataGrid}>
                                                <div className={styles.noDataContent}>
                                                    <HiDocumentText size={48} color="#94a3b8" />
                                                    <p>No documents purchased yet.</p>
                                                </div>
                                            </div>
                                        )}
                                    </div>

                                    {paginationData.totalPages > 0 && (
                                        <div className={styles.pagination}>
                                            <button
                                                className={styles.pageBtn}
                                                onClick={() => handlePageChange(currentPage - 1)}
                                                disabled={currentPage === 1}
                                            >
                                                Previous
                                            </button>
                                            <div className={styles.pageInfo}>
                                                Page <span>{currentPage}</span> of {paginationData.totalPages}
                                            </div>
                                            <button
                                                className={styles.pageBtn}
                                                onClick={() => handlePageChange(currentPage + 1)}
                                                disabled={currentPage === paginationData.totalPages}
                                            >
                                                Next
                                            </button>
                                        </div>
                                    )}
                                </>
                            ) : (
                                <div className={styles.loginRequiredWrapper}>
                                    <div className={styles.loginRequiredContent}>
                                        <div className={styles.loginIconContainer}>
                                            <FaShieldAlt size={48} color="#3b82f6" />
                                        </div>
                                        <h2>Login Required</h2>
                                        <p>Please login to view your purchased documents and company data.</p>
                                        <button className={styles.loginRedirectBtn} onClick={() => navigate("/login", { state: { from: "/mca-documents" } })}>
                                            Login Now
                                        </button>
                                    </div>
                                </div>
                            )}
                        </div>
                    )}

                    {activeTab === 'buyNew' && (
                        <div className={styles.buyNewTabContainer}>
                            <div className={styles.contentCard}>
                                <div className={styles.buyNewHeader}>
                                    <h3>Search Company</h3>
                                    <p>Search by company name or CIN number.</p>
                                </div>
                                <div className={styles.buyNewSearchContainer}>
                                    <FaSearch className={styles.searchIcon} color="#6b7280" />
                                    <input
                                        type="text"
                                        placeholder={isLoggedIn ? "e.g. Reliance Industries or L17110MH1973PLC019786" : "Login to search company data..."}
                                        className={`${styles.searchInput} ${buyNewSearchTerm.length > 0 ? styles.activeSearchInput : ""} ${!isLoggedIn ? styles.disabledSearch : ""}`}
                                        value={buyNewSearchTerm}
                                        onChange={(e) => setBuyNewSearchTerm(e.target.value)}
                                        disabled={!isLoggedIn}
                                    />
                                </div>
                                {!isLoggedIn && (
                                    <p className={styles.loginHint}>
                                        <FaRegClock /> You need to be logged in to search and buy company records.
                                    </p>
                                )}
                            </div>

                            {isLoggedIn && (isSearching || searchResults.length > 0 || (buyNewSearchTerm.length >= 3 && !isSearching)) && (
                                <div className={styles.resultsWrapper}>
                                    <div className={styles.resultsCountHeader}>
                                        {isSearching ? "Searching..." : `${searchResults.length} ${searchResults.length === 1 ? 'result' : 'results'} found`}
                                    </div>
                                    <div className={styles.resultsList}>
                                        {isSearching ? (
                                            <div className={styles.loaderContainer}>
                                                <RotatingLines
                                                    height="40"
                                                    width="40"
                                                    strokeColor="#3b82f6"
                                                    strokeWidth="5"
                                                    animationDuration="0.75"
                                                    visible={true}
                                                />
                                            </div>
                                        ) : (
                                            searchResults.map((company, index) => (
                                                <div key={index} className={styles.resultCard}>
                                                    <div className={styles.resultLeft}>
                                                        <div className={styles.resultIconContainer}>
                                                            <HiDocumentText size={20} color="#3b82f6" />
                                                        </div>
                                                        <div className={styles.resultInfo}>
                                                            <h4 className={styles.resultCompanyName}>{company.CompanyName || company.entityName}</h4>
                                                            <div className={styles.resultMeta}>
                                                                <span className={styles.resultCinPill}>{company.CIN || company.cin}</span>
                                                                {/* <span className={styles.resultState}>{company.State || "N/A"}</span> */}
                                                                <span className={styles.resultTypePill}>{company.CompanyCategory || "Private"}</span>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className={styles.resultActions}>
                                                        {company.isInCart === 1 ? (
                                                            <button
                                                                className={styles.removeFromCartBtn}
                                                                onClick={() => handleRemoveFromCart(company)}
                                                                disabled={removingFromCartCIN === (company.CIN || company.cin)}
                                                            >
                                                                <FaShoppingCart size={16} />
                                                                {removingFromCartCIN === (company.CIN || company.cin) ? "Removing..." : "Remove from Cart"}
                                                            </button>
                                                        ) : (
                                                            <button
                                                                className={styles.addToCartBtn}
                                                                onClick={() => handleAddToCart(company)}
                                                                disabled={addingToCartCIN === (company.CIN || company.cin)}
                                                            >
                                                                <FaShoppingCart size={16} />
                                                                {addingToCartCIN === (company.CIN || company.cin) ? "Adding..." : "Add to Cart"}
                                                            </button>
                                                        )}
                                                        <button
                                                            className={styles.buyBtnResult}
                                                            onClick={() => handleBuyClick(company)}
                                                            disabled={buyingCIN === (company.CIN || company.cin)}
                                                        >
                                                            <MdOutlineCreditCard size={18} />
                                                            {buyingCIN === (company.CIN || company.cin) ? "Processing..." : `Buy · ₹${documentPrice}`}
                                                        </button>
                                                    </div>
                                                </div>
                                            ))
                                        )}
                                        {!isSearching && searchResults.length === 0 && buyNewSearchTerm.length >= 3 && (
                                            <div className={styles.noResults}>No companies found matching your search.</div>
                                        )}
                                    </div>
                                </div>
                            )}
                        </div>
                    )}
                </div>

                {/* Billing Modal */}
                {showBillingModal && (
                    <div className={styles.modalOverlay}>
                        <div className={styles.modalContent}>
                            <div className={styles.modalHeader}>
                                <div>
                                    <h2>Billing Details</h2>
                                    <p>Enter your billing address for invoice generation</p>
                                </div>
                                <button className={styles.closeBtn} onClick={() => setShowBillingModal(false)}>&times;</button>
                            </div>
                            <div className={styles.modalBody}>
                                <div className={styles.formRow}>
                                    <div className={styles.formGroup}>
                                        <label>Full Name *</label>
                                        <input type="text" name="fullName" value={billingDetails.fullName} onChange={handleInputChange} placeholder="John Doe" />
                                    </div>
                                    <div className={styles.formGroup}>
                                        <label>Email *</label>
                                        <input type="email" name="email" value={billingDetails.email} onChange={handleInputChange} placeholder="you@example.com" />
                                    </div>
                                </div>
                                <div className={styles.formGroup}>
                                    <label>Phone *</label>
                                    <input type="text" name="mobileNumber" value={billingDetails.mobileNumber} onChange={handleInputChange} placeholder="+91 98765 43210" />
                                </div>
                                <div className={styles.formGroup}>
                                    <label>Address Line 1 *</label>
                                    <input type="text" name="address1" value={billingDetails.address1} onChange={handleInputChange} placeholder="Building / Street" />
                                </div>
                                <div className={styles.formGroup}>
                                    <label>Address Line 2</label>
                                    <input type="text" name="address2" value={billingDetails.address2} onChange={handleInputChange} placeholder="Landmark (optional)" />
                                </div>
                                <div className={styles.formRow}>
                                    <div className={styles.formGroup}>
                                        <label>City *</label>
                                        <input type="text" name="city" value={billingDetails.city} onChange={handleInputChange} placeholder="Mumbai" />
                                    </div>
                                    <div className={styles.formGroup}>
                                        <label>State *</label>
                                        <select
                                            name="state"
                                            value={billingDetails.state}
                                            onChange={handleInputChange}
                                            className={styles.stateSelect}
                                        >
                                            <option value="">Select State</option>
                                            {statesList.map((st) => (
                                                <option key={st.stateId} value={st.stateName}>
                                                    {st.stateName}
                                                </option>
                                            ))}
                                        </select>
                                    </div>
                                    <div className={styles.formGroup}>
                                        <label>Pincode *</label>
                                        <input type="text" name="pincode" value={billingDetails.pincode} onChange={handleInputChange} placeholder="400001" />
                                    </div>
                                </div>
                                <div className={styles.gstSection}>
                                    <label>GSTIN (Optional)</label>
                                    <input type="text" name="GSTIN" value={billingDetails.GSTIN} onChange={handleInputChange} placeholder="22AAAAA0000A1Z5" />
                                    <p className={styles.gstNote}>Enter your GST number for a GST-compliant invoice</p>
                                </div>
                                <div className={styles.summarySection}>
                                    <div className={styles.summaryLine}>
                                        <span>Plan</span>
                                        <span>MCA Documents</span>
                                    </div>
                                    <div className={styles.summaryLine}>
                                        <span>Subtotal</span>
                                        <span>₹{subtotal.toLocaleString("en-IN")}</span>
                                    </div>
                                    <div className={styles.summaryLine}>
                                        <span>GST ({gstPercentage}%)</span>
                                        <span>₹{Math.round(gstAmount).toLocaleString("en-IN")}</span>
                                    </div>
                                    <div className={`${styles.summaryLine} ${styles.finalTotal}`}>
                                        <span>Total</span>
                                        <span className={styles.totalVal}>₹{Math.round(roundedTotal).toLocaleString("en-IN")}</span>
                                    </div>
                                </div>
                                <button className={styles.proceedBtn} onClick={handleFinalPayment}>
                                    Proceed to Pay ₹{Math.round(roundedTotal).toLocaleString("en-IN")}
                                </button>
                                <p className={styles.secureNote}>
                                    <FaShieldAlt /> Secure payment • Invoice will be emailed
                                </p>
                            </div>
                        </div>
                    </div>
                )}
            </div>
            <Footer />
        </>
    );
};

export default MCADocumentsPage;
